import axios from 'axios'
import router from "@/router/index";
import Vue from "vue";
import JwtToken from "@/services/jwt-token-numerama";


let api = 'http://localhost:8001/';

if (process.env.NODE_ENV !== 'development') {
    api = 'https://app.numerama.com.br'
}

const http = axios.create({
    baseURL: api,
    headers: {
        'Content-Type': 'application/json',
    }
})


http.interceptors.request.use((config) => {
    const token = JwtToken.getAuthorizationHeader()
    if (token) {
        config.headers.Authorization = token
    }
    return config
}, (err) => {
    return Promise.reject(err)
})

http.interceptors.response.use((response) => {
    return response
}, (error) => {
    if (error.response.status !== undefined && (error.response.status === 401 || error.response.status === 419)) {
        let originalRequest = error.config
        return JwtToken.refreshToken().then(() => {
            originalRequest.headers['Authorization'] = JwtToken.getAuthorizationHeader()
            return Vue.httpNumerama(originalRequest);
        }).catch(() => router.push({name: 'logout'}));
    }
    return Promise.reject(error)
})

export default http
